import { render } from "./MySupplyList.vue?vue&type=template&id=bf27b0e2&scoped=true&ts=true&lang=pug"
import script from "./MySupplyList.vue?vue&type=script&setup=true&lang=ts"
export * from "./MySupplyList.vue?vue&type=script&setup=true&lang=ts"

import "./MySupplyList.vue?vue&type=style&index=0&id=bf27b0e2&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf27b0e2"]])

export default __exports__